export enum CustomApiExceptionType {
  DOMAIN_SSO_EXISTS_EXCEPTION = 'DomainSsoExistsException',
  INVALID_COMPANY_DOMAIN_EXCEPTION = 'InvalidCompanyDomainException',
  SSO_NOT_CONFIGURED_EXCEPTION = 'SsoNotConfiguredException'
}
